import { legacy_createStore as createStore, combineReducers } from "redux";
import {
  redivizUser,
  appSettings,
  INITIAL_STATE_USER,
  loadAppSettingsSessionStorage,
} from "./reducers";

const INITIAL_STATE = {
  redivizUser: INITIAL_STATE_USER,
  appSettings: loadAppSettingsSessionStorage(),
};

const reducers = {
  redivizUser,
  appSettings,
};
const rootReducer = combineReducers(reducers);

export const ConfigureTheStore = () => {
  const store = createStore(
    rootReducer,
    INITIAL_STATE,
    window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__(),
  );
  return store;
};
